export default __webpack_public_path__ + "public/images/bg_wid_gradient.png";